import { useState } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import LoadingButton from "@mui/lab/LoadingButton";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";

function ConfirmationPopup(props) {
  const [loading, setLoading] = useState(false);

  const ok = () => {
    if (props.dcrAction == "approve") {
      setLoading(true);
      props.handleApprove();
    } else if (props.dcrAction == "reject") {
      setLoading(true);
      props.handleReject();
    }
  };

  const cancel = () => {
    props.closePopup();
  };

  return (
    <Dialog
      maxWidth={"md"}
      aria-labelledby="confirmation-dialog-title-1"
      open={true}
      keepMounted
    >
      <DialogTitle id="confirmation-dialog-title">{props.popUpMessage.title}</DialogTitle>
      <DialogContent dividers id="newhcp-text">
        {props.popUpMessage.message}
      </DialogContent>
      <DialogActions className="_wg-dynamic-text">
        <LoadingButton
          className="btn btn-secondry border request"
          style={{ textAlign: "right", float: "right", border: "none" }}
          loading={loading}
          loadingPosition="end"
          endIcon={<DoneIcon style={{ fontSize: "medium" }} />}
          variant="outlined"
          onClick={() => ok()}
        >
          Yes
        </LoadingButton>

        <LoadingButton
          className="btn btn-secondry border"
          style={{ textAlign: "right", float: "right", border: "none" }}
          loadingPosition="end"
          endIcon={<CloseIcon style={{ fontSize: "medium" }} />}
          color="error"
          variant="outlined"
          onClick={() => cancel()}
        >
          No
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationPopup;
